// extracted by mini-css-extract-plugin
export default {"item":"ProvidersItemFooterItem_item__pxl1K","qty":"ProvidersItemFooterItem_qty__8Ilfa"};